import { User } from "../gateway/User/User";

export class PasswordRecoverUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ email = "", options = {} } = {}) {
        const payload = this.sanitizeInput({ email, options });
        if (!payload.email) return null;
        try {
            const response = await this.UserGateway.passwordRecover(
                payload.email,
                payload.options
            );
            if (response?.name === "Error") throw new Error(response.message);
            return response;
        } catch (error) {
            throw new Error(`${error?.message || "Erro ao recuperar senha"}`);
        }
    }

    sanitizeInput({ email = "", options = {} } = {}) {
        const sanitizedEmail = String(email).trim();
        const sanitizedOptions =
            options && typeof options === "object" ? { ...options } : {};
        return {
            email: sanitizedEmail,
            options: sanitizedOptions
        };
    }
}
